var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m487.127 408.877h-462.254v-324.563c0-7.802 6.325-14.127 14.127-14.127h433.999c7.802 0 14.127 6.325 14.127 14.127v324.563z",
    fill: "#698ed5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.999 70.187h-20.581c7.802 0 14.127 6.325 14.127 14.127v258.108c0 16.05-13.011 29.061-29.061 29.061h-412.611v37.394h441.672 20.581v-37.394-287.169c.001-7.802-6.324-14.127-14.127-14.127z",
    fill: "#4073c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.426 352.064v-245.668c0-2.02 1.637-3.657 3.657-3.657h389.833c2.02 0 3.657 1.637 3.657 3.657v245.667c0 2.02-1.637 3.657-3.657 3.657h-389.833c-2.019.001-3.657-1.637-3.657-3.656z",
    fill: "#ddeafb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m450.917 102.74h-20.525c2.02 0 3.657 1.637 3.657 3.657v245.667c0 2.02-1.637 3.657-3.657 3.657h20.525c2.02 0 3.657-1.637 3.657-3.657v-245.668c0-2.019-1.638-3.656-3.657-3.656z",
    fill: "#cbe2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m489.862 441.813h-467.724c-12.226 0-22.138-9.911-22.138-22.138v-24.475c0-3.825 3.101-6.926 6.926-6.926h498.148c3.825 0 6.926 3.101 6.926 6.926v24.475c0 12.227-9.912 22.138-22.138 22.138z",
    fill: "#3b66c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m505.074 388.274h-20.335c3.825 0 6.926 3.101 6.926 6.926v24.475c0 12.227-9.912 22.138-22.138 22.138h20.334c12.227 0 22.138-9.911 22.138-22.138v-24.475c.001-3.826-3.1-6.926-6.925-6.926z",
    fill: "#30579d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.475 415.043h-70.95c-2.985 0-5.702-1.721-6.977-4.42l-10.559-22.35h106.022l-10.559 22.35c-1.275 2.699-3.992 4.42-6.977 4.42z",
    fill: "#ddeafb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.429 211.355 60.155-4.767 58.595-51.16 108.188 17.387 71.56-22.216v170.061h-298.498z",
    fill: "#dd636e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m103.421 219.082c-3.991 0-7.373-3.069-7.694-7.116-.337-4.254 2.838-7.976 7.092-8.313l57.609-4.565 56.67-49.48c1.728-1.51 4.04-2.17 6.308-1.809l106.4 17.101 69.829-21.68c4.077-1.265 8.404 1.013 9.67 5.089 1.265 4.075-1.013 8.404-5.089 9.67l-71.558 22.216c-1.137.353-2.338.439-3.517.249l-104.611-16.813-55.865 48.777c-1.249 1.092-2.817 1.752-4.471 1.882l-60.155 4.768c-.206.016-.414.024-.618.024z",
    fill: "#da4a54"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m103.429 283.641 64.456-35.55 56.289 21.922 114.947-58.658 62.806 55.103v54.202h-298.498z",
    fill: "#90d8f9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m103.436 291.368c-2.723 0-5.364-1.443-6.773-3.996-2.06-3.736-.702-8.436 3.034-10.497l64.456-35.55c2.006-1.107 4.402-1.267 6.535-.434l53.059 20.664 111.86-57.083c2.821-1.438 6.23-1.013 8.608 1.074l62.806 55.103c3.207 2.814 3.526 7.696.712 10.903-2.814 3.206-7.696 3.526-10.903.712l-58.866-51.646-110.279 56.276c-1.965 1.003-4.265 1.117-6.316.317l-52.92-20.61-61.29 33.804c-1.182.654-2.461.963-3.723.963z",
    fill: "#75cef9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m408.571 328.387h-305.142c-4.268 0-7.726-3.459-7.726-7.726v-182.861c0-4.268 3.459-7.726 7.726-7.726 4.268 0 7.726 3.459 7.726 7.726v175.134h297.416c4.268 0 7.726 3.459 7.726 7.726 0 4.268-3.458 7.727-7.726 7.727z",
    fill: "#30579d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/line-chart.1698d1990a7a5c77e1fafc2e660b031b.svg";
export { ForwardRef as ReactComponent };